var _title, _feGaussianBlur, _feOffset, _feComponentTransfer, _feComposite, _feMerge;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-filter-0",
    x: -100,
    y: -100,
    width: 1000,
    height: 1000,
    filterUnits: "userSpaceOnUse"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Drop Shadow")), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 1,
    result: "gaussian-blur-0"
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    result: "offset-0",
    in: "gaussian-blur-0"
  })), _feComponentTransfer || (_feComponentTransfer = /*#__PURE__*/React.createElement("feComponentTransfer", {
    result: "offsetblur",
    in: "offset-0"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    id: "spread-ctrl",
    type: "linear",
    slope: 1
  }))), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0,0,0,0.3)",
    x: 0,
    y: 0,
    result: "flood-0",
    style: {}
  }), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in2: "offsetblur",
    operator: "in",
    result: "composite-0",
    in: "flood-0"
  })), _feMerge || (_feMerge = /*#__PURE__*/React.createElement("feMerge", {
    result: "merge-0"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "composite-0"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(255, 255, 255)",
      fill: "rgb(0, 128, 255)",
      strokeWidth: 2,
      filter: "url(#drop-shadow-filter-0)",
      mixBlendMode: "multiply"
    },
    cx: 11,
    cy: 9,
    r: 8
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLocation);
export default __webpack_public_path__ + "static/media/myLocation.284ff209.svg";
export { ForwardRef as ReactComponent };